const cepMask = (value) => {
  if (value){
    return value.replace(/(^[0-9]{5})(\d)/, "$1-$2")
  }else {
    return ''
  }
};

export default cepMask;